import { createFinishStepContent } from '../FinishStepContent';
import { closeSidebarPanel, openDataPlatformSubmenu } from '../sidebarHelpers';

const exploreProfiles = (baseUrl, navigate, profile, user) => {
  return {
    id: 'exploreProfiles',
    title: 'Explore Profiles',
    steps: [
      {
        selector: '[data-tour="dataPlatformLink"]',
        content: <p>Click on the "Data Platform" menu item in the navigation.</p>,
      },
      {
        actionBefore: () => openDataPlatformSubmenu('[data-tour="profilesLink"]'),
        selector: '[data-tour="profilesLink"]',
        content: <p>Click on the "Profiles" in the navigation</p>,
      },
      {
        actionBefore: () => {
          closeSidebarPanel();
          navigate(`${baseUrl}/profiles?showAnonymous=false`, true);
        },
        selector: '[data-tour="profilesPageTable"]',
        content: (
          <>
            <p>In the Profiles section, you can explore all data which has been gathered about your customers.</p>
            <p>
              This includes anonymous and recognized profiles. Once an anonymous profile is associated with an email
              address all data is merged into one record.
            </p>
          </>
        ),
      },
      {
        selector: '[data-tour="profilesPageTable"]',
        content: (
          <>
            <p>
              This data includes product interactions, purchases, all communication sent to that user, delivery status,
              and customer interactions with that communication.
            </p>
            <p>
              The recent events section allows you to explore what pages were visited by the user, what campaigns they
              entered, whether they opened the emails you sent them etc.
            </p>
          </>
        ),
      },
      {
        selector: '[data-tour="profilesPageFirstProfileLink"]',
        content: <p>Click on the link of the profile that you want to view.</p>,
      },
      {
        actionBefore: () => navigate(`${baseUrl}/profiles/${encodeURIComponent(profile.profileId)}/events`, true),
        selector: '[data-tour="profileDetailsEvents"]',
        content: (
          <p>
            Releva starts observing your customers even if there are no Releva elements shown to the customers yet. In
            the following sections, you can see recent customer interactions.
          </p>
        ),
      },
      {
        selector: '[data-tour="profileDetailsEvents"]',
        content: (
          <p>
            The recent events section allows you to explore what pages were visited by the user, what campaigns they
            entered, whether they opened the emails you sent them etc.
          </p>
        ),
      },
      {
        selector: '[data-tour="profilesDetailsEventsFilter"]',
        content: <p>You can also search by specific events in the Filter by event type field above the events list.</p>,
      },
      {
        selector: '[data-tour="profileDetailsProductInteractionsContent"]',
        content: <p>Click on the "Product Interactions" tab.</p>,
      },
      {
        actionBefore: () =>
          navigate(`${baseUrl}/profiles/${encodeURIComponent(profile.profileId)}/productInteractions`, true),
        selector: '[data-tour="profileDetailsProductInteractionsContent"]',
        content: (
          <p>
            Here you can explore what product categories your customer was interested in, which exact products they
            viewed, and what they added to the cart.
          </p>
        ),
      },
      {
        selector: '[data-tour="profileDetailsAggregatedStatsContent"]',
        content: <p>Click on the "Aggregated Statistics" tab.</p>,
      },
      {
        actionBefore: () =>
          navigate(`${baseUrl}/profiles/${encodeURIComponent(profile.profileId)}/aggregatedStats`, true),
        selector: '[data-tour="profileDetailsAggregatedStatsContent"]',
        content: (
          <p>
            This tab allows you to see aggregated statistics for your customer's value, the number of orders, email open
            rate, etc. for the last month or the last 3 months.
          </p>
        ),
      },
      {
        actionBefore: () => navigate(`${baseUrl}/guide`, true),
        selector: '[data-tour="userGuideHeading"]',
        content: createFinishStepContent(),
      },
    ],
    isComplete: !!user.userActions.find((a) => a.action === 'taskCompleted' && a.context.task === 'exploreProfiles'),
  };
};

export default exploreProfiles;
